
export default [
    {
        path:'/spm-template',
        name: 'spm-template',
        component:() => import ('@/components/page/spm/spm-template/spm-template'),
        meta: { title:'nav.spmTemplate' },
    },
    {
        path:'/spm-genera',
        name: 'spm-genera',
        component:() => import ('@/components/page/spm/spm-genera/spm-genera'),
        meta: { title:'nav.spmGenera' },
    },
    {
        path:'/spm-manage',
        name: 'spm-manage',
        component:() => import ('@/components/page/spm/spm-manage/spm-manage-search'),
        meta: { title:'nav.spmManage' },
    },
    {
        path:'/spm-manage-detail',
        name: 'spm-manage-detail',
        component:() => import ('@/components/page/spm/spm-manage/spm-manage-detail'),
        meta: { title:'common.details' },
    },
    {
        path:'/spm-manage-add',
        name: 'spm-manage-add',
        component:() => import ('@/components/page/spm/spm-manage/spm-manage-add'),
        meta: { title:'common.add' },
    },
]
